import PropTypes from "prop-types";
import classes from "./Table.module.css";

const Table = (props) => {
  const { columns, data } = props;

  return (
    <table className={classes["table"]}>
      <thead>
        <tr>
          {columns.map((column, index) => (
            <th
              key={index}
              className={classes["table__header-cell"]}
              style={{
                textAlign: column.align,
                paddingInlineStart: column.paddingStart,
                width: column.width,
              }}
            >
              {column.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((dataRow, rowIndex) => (
          <tr key={rowIndex} className={classes["table__row"]}>
            {columns.map((column, colIndex) => (
              <td
                key={colIndex}
                className={classes["table__data-cell"]}
                style={{
                  textAlign: column.align,
                  width: column.width,
                  paddingInlineStart: column.paddingStart,
                  verticalAlign: column.verticalAlign,
                }}
              >
                {dataRow[column.dataIndex]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Table;

Table.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      dataIndex: PropTypes.string,
      width: PropTypes.string,
    })
  ),
};
